/* eslint-disable */
import { Component } from 'react';
import { Trans } from 'Helpers';
import { Modal, ModalBody, Button, ModalHeader, ModalFooter } from 'reactstrap'
import {Images} from 'Helpers';

class ConfirmationModal extends Component {
  
  render() {
    const {isOpen, toggle, userBalance, SelectedData, ConfirmContest, AppMasterData} = this.props
    
    
    return (
      <Modal  isOpen={isOpen} size='sm' centered className='confirmation-modal width-modal'>
        <div onClick={toggle} className='close-btn'>
          <i className="icon-cancel"/>
        </div>
        <div className='confirm-header'>
          <div className='image-wrapper'>
            <div className='image-outer'>
              <img src={Images.CONFIRM} alt="" />
            </div>
          </div>
        </div>
        <h4 className='confrim-head'>Confirmation</h4>
        <ModalBody>
          <div className="confirm-body-wrap">
            <div className='confirm-txt'>
              <div>Current Balance</div>
              {userBalance && <div className='confirm-fund'>

                {
                 ( SelectedData.price_type == 0 || SelectedData.price_type == 1)   ? 

                  `${AppMasterData.CURRENCY_CODE} ${userBalance.amount}` : 
                 <>
                 <img
                 className="coin-img"
                 src={Images.IC_COIN}
                 alt="coin"
               />
                 {userBalance.coins}
                 </>
                }
                
              </div>}
            </div>
            <p>The total balance available for joining this contest is the sum of Deposit Amount + Winnings.</p>
            <div className='confirm-txt spc-t'>
              <div>Joining Amount</div>
              <div className='confirm-fund'>
                {SelectedData.entry_fee == 0 ? (
                    "FREE"
                  ) : SelectedData.price_type == 0 || SelectedData.price_type == 1   ? (
                    <div>{`${AppMasterData.CURRENCY_CODE} ${SelectedData.entry_fee}`}</div>
                  ) : (
                    <div className="coin-wrap">
                      <img
                        className="coin-img"
                        src={Images.IC_COIN}
                        alt="coin"
                      />
                      {SelectedData.entry_fee}
                    </div>
                  )}
              </div>
            </div>
            <p>By joining this contest, you accept Fantasy Sports T&C’s. I also agree to be contacted by Fantasy Sports and their partners. <span>Go to T&C</span></p>
          </div>
        </ModalBody>
        <ModalFooter>
          <button onClick={ConfirmContest} className='btn btn-join'>Confirm</button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default ConfirmationModal;
